<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="m933.8 894-199-198.9 5.7-7c26.7-32.5 47.4-68.8 61.7-108 14.8-40.6 22.3-83.2 22.3-126.8C824.5 248.6 658 82 453.2 82S82 248.5 82 453.3s166.5 371.4 371.3 371.3c43.6 0 86.2-7.5 126.8-22.3 39.3-14.3 75.6-35.1 108.1-61.7l7-5.7L894 933.8c5.3 5.3 12.3 8.2 19.9 8.2 7.6 0 14.7-2.9 20-8.3 5.3-5.3 8.2-12.4 8.2-19.9s-3.1-14.5-8.3-19.8zM453.2 768.5c-173.8 0-315.1-141.3-315.1-315.1s141.4-315.1 315.1-315.1 315.1 141.3 315.1 315.1S627 768.5 453.2 768.5z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M371.4 477.5c-11.6-4-22.5-10.6-31.8-19.8-32.5-32.5-32.5-85.3 0-117.8s85.4-32.5 117.8 0c9.2 9.2 15.9 20.2 19.8 31.8 19.2-4.3 39.1-4.5 58.4-.6-5.2-26.1-18-51-38.2-71.2-54.6-54.6-143.4-54.6-198 0-54.6 54.6-54.6 143.4 0 198 20.2 20.2 45.1 32.9 71.2 38.2-3.7-19.5-3.5-39.4.8-58.6z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M606.9 409.1c-20.2-20.2-45.1-32.9-71.2-38.2 3.9 19.3 3.7 39.2-.6 58.4 11.6 4 22.5 10.6 31.8 19.8 32.5 32.5 32.5 85.4 0 117.8-32.5 32.5-85.4 32.5-117.8 0-9.2-9.2-15.9-20.2-19.8-31.8-19.2 4.3-39.1 4.5-58.4.6 5.2 26.1 18 51 38.2 71.2 54.6 54.6 143.4 54.6 198 0 54.4-54.4 54.4-143.2-.2-197.8z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M497.5 497.7c-19.5 19.5-43.3 32-68.4 37.6-19.2 4.3-39.1 4.5-58.4.6-3.9-19.3-3.7-39.2.6-58.4 5.6-25.1 18.1-48.9 37.6-68.4 19.5-19.5 43.3-32 68.4-37.6 19.2-4.3 39.1-4.5 58.4-.6 3.9 19.3 3.7 39.2-.6 58.4-5.6 25.1-18.1 48.9-37.6 68.4z" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
